import { observer } from 'mobx-react-lite';
import { Icon, Spinner, SpinnerSize } from '@fluentui/react/lib';
import { ControlIcons } from 'owa-control-icons';
import * as React from 'react';
import { getViewStateById } from '../selectors/collabSpaceSelectors';
import {
    collabSpaceBlockDialogLinkLoading,
    collabSpaceBlockDialogLinkLoaded,
    collabSpaceBlockDialogTitleLoading,
    collabSpaceBlockDialogTitleLoaded,
    collabSpaceBlockDialogOkText,
    collabSpaceBlockDialogCancelText,
} from './CollabSpace.locstring.json';
import loc from 'owa-localize';

const styles = require('./CollabSpaceBlockDialog.scss');

export interface OwaFluidPerfLoggingHelperProps {
    viewStateId: string;
}

export default observer(function CollabSpaceBlockDialog(props: OwaFluidPerfLoggingHelperProps) {
    if (!props.viewStateId) {
        return null;
    }

    const viewState = getViewStateById(props.viewStateId);
    if (!viewState) {
        return null;
    }
    const { shareLink } = viewState;
    let labelString: string = loc(collabSpaceBlockDialogLinkLoading);
    let iconToShow = <Spinner size={SpinnerSize.medium} className={styles.spinner} />;

    if (shareLink) {
        labelString = loc(collabSpaceBlockDialogLinkLoaded);
        iconToShow = <Icon className={styles.checkMarkIcon} iconName={ControlIcons.CheckMark} />;
    }

    return (
        <div className={styles.dialogContainer}>
            {iconToShow}
            <div>{labelString}</div>
        </div>
    );
});

export function getConfirmationOptions(viewStateId: string) {
    if (!viewStateId) {
        return null;
    }

    const viewState = getViewStateById(viewStateId);
    if (!viewState) {
        return null;
    }

    const { shareLink } = viewState;
    return {
        title: shareLink
            ? loc(collabSpaceBlockDialogTitleLoaded)
            : loc(collabSpaceBlockDialogTitleLoading),
        okText: loc(collabSpaceBlockDialogOkText),
        cancelText: loc(collabSpaceBlockDialogCancelText),
        shouldDisableOkButton: !shareLink,
    };
}
